"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authSuitePendingRequestRegistry = void 0;
var cachedRequests = {};
var registerPendingRequest = function (param) {
    var requestKey = param.requestKey, pendingRequestPromise = param.pendingRequestPromise;
    cachedRequests[requestKey] = pendingRequestPromise;
};
var clearRegisteredRequest = function (param) {
    cachedRequests[param.requestKey] = undefined;
};
var getPendingRequest = function (param) {
    return cachedRequests[param.requestKey];
};
exports.authSuitePendingRequestRegistry = {
    clearRegisteredRequest: clearRegisteredRequest,
    getPendingRequest: getPendingRequest,
    registerPendingRequest: registerPendingRequest,
};
